import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'bai-client-info-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonModule, ButtonDirective],
  template: `
    <button
      pButton
      type="button"
      [outlined]="true"
      disabled
      class="w-full text-left flex items-stretch justify-between p-0 rounded-lg overflow-hidden focus-visible:ring-2 focus-visible:ring-[var(--p-primary-color)]"
      style="margin-bottom: .5rem"
    >
      <div
        class="text-left font-normal text-[inherit] text-base leading-normal w-full"
      >
        <div class="w-full flex justify-between">
          <div class="flex items-center gap-3 overflow-hidden">
            <p-skeleton
              shape="circle"
              size="2.5rem"
              styleClass="flex-shrink-0"
            />

            <div class="flex flex-col min-w-0 overflow-hidden gap-1 gap-y-1">
              <div  style="margin-bottom: .25rem"><p-skeleton width="8rem" height="0.875rem"/></div>
              <div  style="margin-bottom: .25rem"><p-skeleton width="10rem" height="0.75rem" /></div>
              <div  style="margin-bottom: .25rem"><p-skeleton width="10rem" height="0.75rem" /></div>
            </div>
          </div>
        </div>
      </div>
    </button>
  `,
  styles: [],
})
export class ClientInfoSkeletonComponent {}
